module.exports = __webpack_public_path__ + "static/media/na.ca899774.svg";